<div class="form-container">
    <h2>Edit Scenario Category</h2>
  
    <form (ngSubmit)="updateCategory()">
      <div class="form-group">
        <label>Title:</label>
        <input type="text" class="form-control" [(ngModel)]="category.title" name="title" required placeholder="Title">
      </div>
      <button type="submit" class="btn btn-primary" [disabled]="isSubmitting">
        {{ isSubmitting ? 'Submitting...' : 'Update Scenario Category' }}
      </button>
    </form>
  </div>
  